export const nofollow = (metaTags?: string): boolean =>
  !!(metaTags?.includes('nofollow') || metaTags?.includes('none'))
export const noindex = (metaTags?: string): boolean =>
  !!(metaTags?.includes('noindex') || metaTags?.includes('none'))
